import { render, staticRenderFns } from "./AllDataCorrectionEscalations.vue?vue&type=template&id=865fc784&scoped=true&"
import script from "./AllDataCorrectionEscalations.vue?vue&type=script&lang=js&"
export * from "./AllDataCorrectionEscalations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865fc784",
  null
  
)

export default component.exports